import { render, staticRenderFns } from "./SendMessageTargetOtherUserRow.vue?vue&type=template&id=5a2ea802&scoped=true&lang=pug"
import script from "./SendMessageTargetOtherUserRow.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetOtherUserRow.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetOtherUserRow.vue?vue&type=style&index=0&id=5a2ea802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ea802",
  null
  
)

export default component.exports